import { productOwnershipPromise } from '@coursera-web/product';
import Q from 'q';

export default function (
  userId: $TSFixMe,
  courseId: $TSFixMe,
  isCourseVerificationEnabled: $TSFixMe,
  s12nId: $TSFixMe
) {
  // Course must be enabled for verification and user must be logged in.
  if (isCourseVerificationEnabled && userId) {
    const promise = Q.all([productOwnershipPromise(userId, courseId, true)]).spread(
      (productOwnership) => {
        const isProductVerificationEnabled = isCourseVerificationEnabled;

        return {
          isProductVerificationEnabled,
          productOwnership,
          s12nId,
        };
      },
      () => null
    );

    promise.done();
    return promise;
  } else {
    const promise = Q(null);
    promise.done();
    return promise;
  }
}
